// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M6.63 8.69C7.1 9.36 7.85 9.8 8.68 9.87C9.5 9.94 10.31 9.65 10.9 9.06L13.2 6.76C14.29 5.67 14.29 3.9 13.2 2.8C12.1 1.71 10.33 1.71 9.24 2.8L7.68 4.36',
  'M9.37 7.31C8.9 6.64 8.15 6.2 7.32 6.13C6.5 6.06 5.69 6.35 5.1 6.94L2.8 9.24C1.71 10.33 1.71 12.1 2.8 13.2C3.9 14.29 5.67 14.29 6.76 13.2L8.32 11.64',
];
